export default __webpack_public_path__ + "c3b6af3a808b3d86e333246865e370e2.glb";